import { ProductName } from '@pypestream/api-services';
import { SmartContext } from '../xstate/smart.xstate-utils';
import { generateBaseURLsToTools } from './generate-base-urls/generate-base-urls';

export const handleGoHome = ({
  accountId,
  redirectedDueToNoToolAccess = false,
  app,
}: {
  accountId: SmartContext['accountId'];
  redirectedDueToNoToolAccess?: boolean;
  app?: ProductName;
}) => {
  const baseURLs = generateBaseURLsToTools(window.location);
  const managerUrl = baseURLs.Manager;

  const baseUrl = managerUrl || window.location.origin;
  const path = accountId ? `/organization/${accountId}` : '';

  let url: URL;
  try {
    if (baseUrl) {
      url = new URL(path, baseUrl);
    } else {
      url = new URL(path || '/', window.location.origin);
    }
  } catch (error) {
    url = new URL(path || '/', window.location.origin);
  }

  if (redirectedDueToNoToolAccess && app) {
    url.searchParams.set('redirectedDueToNoToolAccess', 'true');
    url.searchParams.set('app', app);
  }

  window.location.href = url.href;
};
